<template>
  <div>
    <FirstPageSlidecomponent :lista="listaprops" />
  </div>
</template>

<script>
import FirstPageSlidecomponent from "../components/FirstPageSlidecomponent.vue";

export default {
  name: "Home",
  components: { FirstPageSlidecomponent },
  data() {
    return {
      listaprops: [
        {
          id: 1,
          rubrik: "Ätran",
          text:
            "A trout is a moment of beauty known only to those who seek it. - Arnold Gingrich",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran7.jpg",
        },
        {
          id: 0,
          rubrik: "Glomma",
          text:
            "I have many loves and Fly-Fishing is one of them; it brings peace and harmony to my being, which I can then pass on to others - Sue Kreutzer",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-glomma/Glomma_031400.jpg",
        },
      ],
    };
  },
};
// @ is an alias to /src
</script>
